import { useCallback, useEffect } from "react";
import { SettingsTab } from "../components/tabs/settings-tab";
import { createFileRoute } from "@tanstack/react-router";
import { useConfigStore } from "@/stores/widget-store";
import { useToast } from "@/hooks/use-toast";
import SkeletonLoader from "@/components/skeleton-loader";

export const Route = createFileRoute("/issue-fixes")({
  component: IssueFixes,
});

function IssueFixes() {
  const { isLoading, fetchConfig, saveConfig } = useConfigStore();
  const { toast } = useToast();
  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const handleSave = useCallback(async () => {
    try {
      await saveConfig();
      toast({
        title: "Setting saved!",
        description: "Clear the cache if you are using any cache plugins.",
        variant: "success",
      });
    } catch {
      toast({
        title: "Failed to save settings",
        description: "Please try again",
        variant: "destructive",
      });
    }
  }, [saveConfig, toast]);
  return (
    <>{isLoading ? <SkeletonLoader /> : <SettingsTab onSave={handleSave} />}</>
  );
}

